import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Download, Edit2, Trash } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import PaginationClassic from '../../components/infrastructure/pagination/PaginationClassic';
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch';
import {
    deleteCollege,
    fetchColleges,
    getColleges,
} from '../../app/reducers/College/collegeSlice';
import { useNavigate } from 'react-router-dom';
import { getMediaLibrary } from '../../app/reducers/MediaLibrary/mediaLibrarySlice';
import { fetchRoles } from '../../app/reducers/Role/roleSlice';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import DangerButton from '../../components/infrastructure/Buttons/DangerButton';
import { getAuth } from '../../app/reducers/Auth/authSlice';
import { toast } from 'react-toastify';
import { exportCsv } from '../../utils/Utils';
import QueryString from 'qs';
import { authAxiosInstance } from '../../utils/axiosConfig';
import { ClipLoader } from 'react-spinners';

const ViewCollege = () => {
    const { college, loading } = useSelector(getColleges);
    const { baseUrl } = useSelector(getMediaLibrary);
    const { user } = useSelector(getAuth);
    const [activeButtonIndex, setActiveButtonIndex] = useState(0);
    const [isDownloading, setIsDownloading] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const debouncedSearch = useCallback(
        _.debounce((search) => {
            console.log('searching');
            dispatch(
                fetchColleges({
                    sort: { name: 1 },
                    search: search,
                    populate: true,
                })
            );
        }, 300),
        []
    );
    const [page, setPage] = useState(1);

    const cols = [
        // {
        //     Header: 'College Photo',
        //     Cell: ({ row }) => {
        //         return (
        //             <div>
        //                 {row.original.photos && (
        //                     <img
        //                         src={baseUrl + row.original.photos[0]}
        //                         height={70}
        //                         width={100}
        //                     />
        //                 )}
        //             </div>
        //         );
        //     },
        // },
        {
            Header: 'College Name',
            Cell: ({ row }) => {
                return <span>{row.original.name}</span>;
            },
        },

        // {
        //     Header: 'Code',
        //     accessor: 'code',
        // },
        // {
        //     Header: 'CL/ACL',
        //     accessor: 'volunteers',
        //     Cell: ({ row }) => {
        //         const volunteers = row.original.volunteers || [];
        //         return (
        //             <ul>
        //                 {volunteers.map((volunteer, index) => (
        //                     <li key={index}>
        //                         {volunteer.role && (
        //                             <span>{volunteer.role.name}</span>
        //                         )}
        //                         &nbsp; - &nbsp; {volunteer.seats}
        //                     </li>
        //                 ))}
        //             </ul>
        //         );
        //     },
        // },

        {
            Header: 'Action',
            Cell: ({ row }) => {
                return (
                    <div className="flex gap-2 items-center cursor-pointer">
                        <PrimaryButton
                            onClick={async () => {
                                navigate(`/college/edit/${row.original._id}`);
                            }}
                            color="blue"
                        >
                            Edit
                        </PrimaryButton>
                        <DangerButton
                            onClick={async () => {
                                await dispatch(
                                    deleteCollege({ id: row.original._id })
                                );
                                dispatch(
                                    fetchColleges({
                                        populate: true,
                                        sort: { name: 1 },
                                        page,
                                    })
                                );
                            }}
                            color="red"
                        >
                            Delete
                        </DangerButton>
                    </div>
                );
            },
        },
    ];
    const data = useMemo(() => (college?.docs ? college.docs : []), [college]);
    console.log("data:::", data)

    const handleDownload = async () => {
        setIsDownloading(true);
        try {
            const query = {
                populate: true,
                sort: { name: 1 },
                limit: 1000,
            };

            const string = QueryString.stringify(query);
            const resp = await authAxiosInstance.get(`/college?${string}`);
            console.log("resp:::", resp?.data?.data?.docs.length)

            if (resp?.data?.data?.docs.length > 0) {
                let mainData = resp?.data?.data?.docs.map((ele, index) => {
                    let { volunteers } = ele;


                    const volunteersString = volunteers?.map((item) =>
                        `${item?.role?.name}-${item?.seats}`
                    ).join(' , ');

                    return {
                        'SR No': index + 1,
                        'College Name': ele?.name,
                        'Volunteers & seats': volunteersString,
                        'Created At': ele?.createdAt ? moment(ele?.createdAt).format('DD-MM-YY hh:mm:ss a') : "--",
                    };
                });

                const fileName = "College Data";
                exportCsv(mainData, fileName);

            }

        } catch (error) {
            console.log(error);
            toast.error('Fail to Download');
        } finally {
            setIsDownloading(false);
        }
    };
    useEffect(() => {
        dispatch(
            fetchColleges({
                populate: true,
                sort: { name: 1 },
                page,
            })
        );
    }, [page]);
    return (
        <PageWithCard heading={'Colleges'}>
            {["Developer", "HOD", "Super User"].includes(user?.role?.name) &&
                activeButtonIndex === 0 && (
                    <div className="mb-4">
                        {isDownloading ? (
                            <ClipLoader color="#FFFFFF" size={18} />
                        ) : (
                            <PrimaryButton onClick={handleDownload}>
                                <Download size={18} className="mr-1" /> Download
                            </PrimaryButton>
                        )}
                    </div>
                )}
            <TableWithHeadingAndGlobalSearch
                loading={loading}
                data={data}
                searchFunction={debouncedSearch}
                columns={cols}
            />
            <PaginationClassic setPage={setPage} paginationDetails={college} />
        </PageWithCard>
    );
};

export default ViewCollege;
